export default function openBlobInNewTab(blob: Blob): boolean {
    const pdfBlob = new Blob([blob], { type: blob.type || 'application/pdf' })
    const url = URL.createObjectURL(pdfBlob)
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')

    if (!newWindow) {
        URL.revokeObjectURL(url)
        return false
    }

    setTimeout(() => URL.revokeObjectURL(url), 60_000)
    return true
}
